import { render } from "./systemStudent.vue?vue&type=template&id=229dbe09&scoped=true"
import script from "./systemStudent.vue?vue&type=script&lang=js"
export * from "./systemStudent.vue?vue&type=script&lang=js"

import "./systemStudent.vue?vue&type=style&index=0&id=229dbe09&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229dbe09"]])

export default __exports__